import axios from "axios";

//Demo
// export const API = "http://backend-demo.lms.learnersuae.com/api/v1";

// export const baseConfig = axios.create({
//     baseURL: "http://backend-demo.lms.learnersuae.com/api/v1",
// });

// local
// export const baseConfig = axios.create({
//     baseURL: "http://192.168.1.35:8001/api/v1",
// });

// export const API = "http://192.168.1.35:8001/api/v1"

//Server

export const API = "https://backend.learnersuae.com/api/v1";

export const baseConfig = axios.create({
    baseURL: "https://backend.learnersuae.com/api/v1",
});

// for all
export default {
    API_ENDPOINT: API,
};
